import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FREE_PANORAMA_SEARCH_DAYS, MAX_PANORAMA_SEARCH_DAYS } from "@/constants/membership";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        "We continuously monitor year-round availability for a vast array of popular airline routes offered by major airline programs, offering you the ultimate in flexibility.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "1. Select Your Preferred Region, Country, or Airports",
      description:
        "With our routes feature, you have the flexibility to choose regions such as Asia, North America, and more. Additionally, you can opt for a specific country you'd like to explore or simply select target airports. When you choose a region or country, we will provide you with the availability information for all the airports within your selected area.",
      img: "https://img.awardtool.com/guides/routes_1.png",
    },
    {
      title: "2. Range Search",
      description:
        "Free users can enjoy a complimentary " + FREE_PANORAMA_SEARCH_DAYS + "-day search using our routes feature, while PRO users can extend their search to an impressive " + MAX_PANORAMA_SEARCH_DAYS + "-day range. Our route search typically delivers results in under 5 seconds, giving you a wide range of choices to consider.",
      img: "https://img.awardtool.com/guides/routes_2.png",
    },
    {
      title: "3. Sorting and Filtering Options",
      description:
        "We offer advanced sorting and filtering options to empower you in finding the best availability to suit your needs.",
      img: "https://img.awardtool.com/guides/routes_filter.png",
    },
    {
      title: "4. Detailed Date Checking",
      description:
        "If you're interested in specific availability, simply click the option button, and we'll load the flight information details for you to make an informed decision.",
      img: "https://img.awardtool.com/guides/routes_3.png",
    },
    {
      title: "5. Year-Round Availability Viewing with Calendar and List Views",
      description:
        "We offer a calendar view that presents year-round availability for a specific route, allowing you to identify the most suitable flight options for your preferences.",
      img: "https://img.awardtool.com/guides/route_7.png",
    },
    {
      title: "6. Accessing Flight Details and Booking Options",
      description:
        "We provide comprehensive details on how to transfer points and direct you to the transfer portal. For most airline programs, we also offer links to their respective websites to facilitate flight bookings.",
      img: "https://img.awardtool.com/guides/routes_5.png",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
